/**
 * this file contains all the endpoints
 *
 * Created by Tom on 18/06/18
 */

// REACT_APP_WEBSITE_URL env variable need to be passed before JS compiled
if (!process.env.REACT_APP_WEBSITE_URL)
    throw new Error('The REACT_APP_WEBSITE_URL environment variable is required but was not specified.')

const websiteUrl = process.env.REACT_APP_WEBSITE_URL
const rootAPIUrl = websiteUrl + '/api'

const config = {
    "endpoints" : {

        // Main website url
        "websiteURL": websiteUrl,

        // Website urls
        "websiteSignInURL": websiteUrl + '/sign-in/',
        "websiteSignOutURL": websiteUrl + '/sign-out/',
       
        "websiteTermsURL": websiteUrl + '/terms-conditions/',
        "websitePrivacyPolicyURL": websiteUrl + '/privacy-policy/',

        

        "rootAPIUrl": rootAPIUrl,
      
        // Funds level specific
        "createFundURL": rootAPIUrl + "/fund/{adviser_id}/create_fund/",
        "updateFundURL": rootAPIUrl + "/fund/{adviser_id}/update_fund/",
        "fetchInProgressFundURL": rootAPIUrl + "/fund/in_progress_fund/{member_id}/",

        "fundsSummaryFetchURL" : rootAPIUrl + "/accounting/funds_summary/",
        "fundsListFetchURL" : rootAPIUrl + "/accounting/funds_list/",
        
        // Individual fund level specific
        "fundFetchURL" :  rootAPIUrl + "/accounting/fund_detail_report/{member_id}/",
        "fundOverallSummaryFetchURL" :  rootAPIUrl + "/accounting/overall_fund_position/{fund_code}/",
        "fundSummaryFetchURL" : rootAPIUrl + "/accounting/fund_summary/{member_id}/",
        "fundDetailedAssetPositionFetchURL" : rootAPIUrl + "/accounting/detailed_fund_asset_position/{fund_code}/",
        "fundCashReconciliationFetchURL" : rootAPIUrl + "/accounting/cash_reconciliation/{member_id}/",
        "fundRequestClassDetailsFetchURL" : rootAPIUrl + "/accounting/request_class_details/{fund_code}/{request_type}/",

        // Documents specific URLs
        "documentListURL" :  rootAPIUrl + "/member-documents/list/{member_id}/",
        "documentDeleteURL" :  rootAPIUrl + "/member-documents/{member_id}/delete/{document_id}/",
        "memberDocumentCategoriesFetchURL" :  rootAPIUrl + "/member-documents/category/list/all/",
        "adviserDocumentUpload" : rootAPIUrl + "/member-documents/{id}/add_member_document/",

        // DocuSign specific URLs
        "docusignListDocuments" :  rootAPIUrl + "/document/list/{id}/",

        // Contributions specific URLs
        "fundContributionsFetchURL" : rootAPIUrl + "/accounting/contributions/{member_id}/",

        // Billing specifi URLs
        "billingFetchURL": rootAPIUrl +"/payments/{member_id}/",
        "billingDownloadURL": rootAPIUrl +"/payments/adviser_download/{member_id}/{id}/",


        // Report direct download URLS
        "generalLetterMinuteReportURL" : rootAPIUrl + "/accounting/reports/general_letter/download/",
        "downloadContributionReportURL" : rootAPIUrl + "/accounting/contributions/download/",
        "downloadFundDetailReportURL" : rootAPIUrl + "/accounting/reports/fund_details/download/",
        "downloadInvestmentSummaryReportURL" : rootAPIUrl + "/accounting/reports/investment_summary/download/",
        "downloadMemberStatementReportURL" : rootAPIUrl + "/accounting/reports/member_statement/download/",
        "downloadRentalPropertyReportURL" : rootAPIUrl + "/accounting/reports/rental_property/download/",

        // Report request URLs
        "reportRequestURL" : rootAPIUrl + "/accounting/reports/request/{fund_code}/{report_name}/",





        "tradingExternalURL": 'https://www.macquarie.com.au/FIM/trading/',

        // fetch url for the list of transactions
        "transactionFetchURL" : rootAPIUrl +"/accounting/transaction_details/{startDate}/{endDate}/",

        // fetch url for the list of Investment
        "investmentFetchURL" : rootAPIUrl +"/accounting/asset_position/{todayDate}/",

        // fetch url for Investment download
        "investmentDownloadURL" : rootAPIUrl +"/accounting/asset_position/download/",

        // fetch url for the list of Portfolio value
        "portfolioFetchURL" : rootAPIUrl +"/accounting/fund_value/{startDate}/{endDate}/",

        // fetch url for Portfolio download
        "portfolioDownloadURL" : rootAPIUrl +"/accounting/investment_summary/download/",

        // fetch member profile data
        "profileFetchURL" :  rootAPIUrl + "/profile/",

        // update member profile data
        "profileUpdateURL" :  rootAPIUrl + "/profile/update/",

        // feth fund detail data
        

        // feth basic fund detail data
        "basicFundFetchURL" :  rootAPIUrl + "/accounting/basic_fund_detail_report/",

        // fetch doc sign link
        "docSignLinkFetchURL" :  rootAPIUrl + "/document/sign-docs-url/",

        // fetch document status
        "doccumentStatusURL" :  rootAPIUrl + "/document/status/",

        // fetch docs data
        "documentsFetchURL" :  rootAPIUrl + "/document/",

        // download doc link
        "documentDownloadURL" :  rootAPIUrl + "/document/{id}/download/",

        // verify auth
        "authVerifyURL": rootAPIUrl + "/auth/verify/",

        // fetch documents signing details data
        "newsFetchURL": rootAPIUrl + "/latest-news/",
        "documentSigningDetails": rootAPIUrl + "/document/signing-details/",

        // fetch member docs data
        "memberDocumentsFetchURL" :  rootAPIUrl + "/member-documents/tree/",

        // upload a document
        "memberDocumentUploadURL" :  rootAPIUrl + "/member-documents/{id}/add_member_document/",        

        // send a referral email
        "sendReferralURL": rootAPIUrl + "/referral/{id}/send/",
    }
}

export default config



// WEBPACK FOOTER //
// ./src/config.js